var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarMoreInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8167 0C16.7563 0 17.4954 0.312744 18.0338 0.932373C18.5665 1.55005 18.8355 2.39893 18.8355 3.49121C18.8355 4.59912 18.3773 5.58398 17.4543 6.44775C16.5265 7.31152 15.4501 7.74609 14.2236 7.74609C13.3019 7.74609 12.5691 7.44873 12.0072 6.85254C11.4457 6.24951 11.1651 5.46948 11.1651 4.49927C11.1651 3.27686 11.6232 2.22339 12.5343 1.32861C13.445 0.443359 14.5388 0 15.8167 0ZM21.0669 30H8.93359V27.6465H11.2136V13.2715H8.93359V11.3979H14.6044C16.0368 11.3979 17.4463 11.1997 18.8386 10.7949V27.6465H21.0669V30Z",
    fill: "#009BA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMoreInfoIcon);
export default __webpack_public_path__ + "static/media/sidebar-more-info-icon.d8094a86da36404a78e7b6d51d0e1fec.svg";
export { ForwardRef as ReactComponent };